import Components from './Time.vue';

const times = {
    install:function(Vue) {
        Vue.component('times', Components)
    }
}

export default times;